import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from '../Univ.js'
function SampleCollect(props) {
    const [startDate, setStartDate] = useState(null);
    const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000));
    const [rows, setRows] = useState([]);
    const [labData, setLabData] = useState([]);
    const [iprows, setIpRows] = useState([]);
    const [iplabData, setIpLabData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const handleStartDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setStartDate(localDate);
    };
    useEffect(() => {
        fetchData();
        fetchIpData();
    }, [startDate]);
    useEffect(() => {
        if (labData.length > 0) {
            setRows(labData);
        }
    }, [labData]);
    useEffect(() => {
        if (iplabData.length > 0) {
            setIpRows(iplabData);
        }
    }, [iplabData]);
    function fetchData() {
        setIsLoading(true);
        const formattedDate = selectedDate.toISOString().substring(0, 10);
        const url = `${baseUrl}sample-view/?start_date=${formattedDate}&end_date=${formattedDate}`;
        axios.get(url)
            .then(response => {
                setLabData(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    function fetchIpData() {
        setIsLoading(true);
        const formattedDate = selectedDate.toISOString().substring(0, 10);
        const url1 = `${baseUrl}sample-view-ip/?start_date=${formattedDate}&end_date=${formattedDate}`;
        axios.get(url1)
            .then(response => {
                setIpLabData(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    const columns = [
        {field: 'lab_id', headerName: 'Appt Id', width: 120},
        {field: 'lab_id__pat_id__pat_id', headerName: 'Patient ID', width: 100},
        {field: 'lab_id__pat_id__patient', headerName: 'Patient', width: 200},
        {field: 'ltest_id__subcat', headerName: 'Test Name', width: 300},
        {field: 'workorder', headerName: 'Work Order No', width: 200},
        {
            field: 'isaccept',
            headerName: 'Order Status',
            width: 100,
            renderCell: (params) => {
                return params.value === 1 ? 'Accepted' : 'Pending';
            },
        },
        {field: 'acceptby', headerName: 'Accept by', width: 100},
        {
            field: 'actions',
            headerName: 'Actions',
            width: 200,
            renderCell: (params) => {
                const labId = params.row.id; // Access lab_id__lab_id
                const ltestId = params.row.ltest_id;    // Access ltest_id
                const appt_id = params.row.lab_id__appt_id;
                return (
                    <Link
                        to={`/create-sample-id/${labId}/${ltestId}/${appt_id}`}
                        className="btn btn-success"
                    >
                        Create Sample Id
                    </Link>
                );
            },
        },
    ];
    const columns1 = [
        {field: 'lab_id', headerName: 'Appt Id', width: 120},
        {field: 'lab_id__pat_id__pat_id', headerName: 'Patient ID', width: 100},
        {field: 'lab_id__pat_id__patient', headerName: 'Patient', width: 200},
        {field: 'ltest_id__subcat', headerName: 'Test Name', width: 300},
        {field: 'workorder', headerName: 'Work Order No', width: 200},
        {
            field: 'isaccept',
            headerName: 'Order Status',
            width: 100,
            renderCell: (params) => {
                return params.value === 1 ? 'Accepted' : 'Pending';
            },
        },
        {field: 'acceptby', headerName: 'Accept by', width: 100},
        {
            field: 'actions',
            headerName: 'Actions',
            width: 200,
            renderCell: (params) => {
                const labId = params.row.id; // Access lab_id__lab_id
                const ltestId = params.row.ltest_id;    // Access ltest_id
                const appt_id = params.row.lab_id__appt_id;
                return (
                    <Link
                        to={`/create-sample-id-ip/${labId}/${ltestId}/${appt_id}`}
                        className="btn btn-success"
                    >
                        Create Sample Id
                    </Link>
                );
            },
        },
    ];
    return (
        <section className="container mt-4">
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
                        <div className="col-sm-9 col-lg-10 controls">
                            <DatePicker selected={selectedDate} onChange={handleStartDateChange}
                                        dateFormat="dd/MM/yyyy"/>
                        </div>
                    </div>
                </div>
            </div>

            {!isLoading && labData.length > 0 ? (
                <div style={{height: "100%", width: "100%"}} className="mt-4">
                    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                        <i className="fa-solid fa-stethoscope" aria-hidden="true" style={{color: 'red'}}></i>
                        Order Accept Lab
                    </h3>
                    <DataGrid className="mt-4"
                              sx={{
                                  boxShadow: 4,
                                  border: 4,
                                  borderColor: 'primary.light',
                                  '& .MuiDataGrid-cell:hover': {
                                      color: 'primary.main',
                                  },
                              }}
                              rows={rows}
                              columns={columns}
                              pageSize={10}
                              slots={{toolbar: GridToolbar}}
                              autoHeight
                    />
                </div>
            ) : (
                <></>
            )}<br></br>
            {!isLoading && iplabData.length > 0 ? (
                <div style={{height: "100%", width: "100%"}} className="mt-4">
                    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                        <i className="fa-solid fa-stethoscope" aria-hidden="true" style={{color: 'red'}}></i>
                        IP Order Accept Lab
                    </h3>
                    <DataGrid className="mt-4"
                              sx={{
                                  boxShadow: 4,
                                  border: 4,
                                  borderColor: 'primary.light',
                                  '& .MuiDataGrid-cell:hover': {
                                      color: 'primary.main',
                                  },
                              }}
                              rows={iprows}
                              columns={columns1}
                              pageSize={10}
                              slots={{toolbar: GridToolbar}}
                              autoHeight
                    />
                </div>
            ) : (
                <></>
            )}<br></br>
        </section>
    )
}
export default SampleCollect;
